import { createAsyncActionTypes } from '../../helpers';

const domain = 'app';

const initApp = createAsyncActionTypes(domain, 'initApp');

export default { initApp };
